import { CatalogTranslate } from './catalogTranslate.model';

const catalogTranslateEN: CatalogTranslate = {
  page: {
    title: 'Catalog',
    tabs: {
      services: 'Services',
      packages: 'Packages',
    },
    search: {
      services: 'Search for a service',
      packages: 'Search for a package',
    },
    emptyState: {
      services: 'No services registered',
      servicesHint: 'Create a new service to get started',
      packages: 'No packages registered',
      packagesHint: 'Create a new package to get started',
    },
  },
  archivedModal: {
    title: 'Archived items',
    openButton: 'Archived',
    tabs: {
      services: 'Services',
      packages: 'Packages',
    },
    empty: 'No archived items.',
    archivedAt: 'Archived on',
    restoreButton: 'Restore',
  },
  list: {
    archived: 'Archived',
    serviceCount: '{{count}} services',
    serviceCountSingular: '{{count}} service',
    actions: {
      detail: 'Detail',
      edit: 'Edit',
      archive: 'Archive',
      restore: 'Restore',
    },
  },
  detail: {
    price: 'Price',
    description: 'Description',
    createdAt: 'Created at',
    archivedAt: 'Archived at',
    includedServices: 'Included services',
    servicePrice: 'Service price: {{price}}',
    actions: {
      edit: 'Edit',
      archive: 'Archive',
      restore: 'Restore',
      close: 'Close detail',
    },
  },
  form: {
    title: {
      createService: 'New service',
      editService: 'Edit service',
      createPackage: 'New package',
      editPackage: 'Edit package',
    },
    fields: {
      name: {
        placeholderService: 'Service name',
        placeholderPackage: 'Package name',
      },
      description: {
        placeholder: 'Description',
      },
      price: {
        placeholder: 'Price ($)',
        frozenHint:
          'Changing the price here does not affect sales already registered — each sale keeps the value agreed at the time',
      },
      imageService: 'Service image',
      imagePackage: 'Package image',
      services: {
        placeholder: 'Select services',
        searchPlaceholder: 'Search service',
        noResults: 'No service found',
      },
    },
    errors: {
      nameRequired: 'Name is required',
      nameMax: 'Name must be at most 100 characters',
      descriptionMax: 'Description must be at most 500 characters',
      pricePositive: 'Price must be greater than zero',
      servicesMin: 'Select at least one service',
    },
    actions: {
      clear: 'Clear',
      save: 'Save',
      saveError: 'Failed to save. Try again.',
    },
  },
  imageUpload: {
    placeholder: 'Drag an image here or click to select',
    hint: 'JPG, PNG or WebP • max 5 MB',
    dragRejected: 'Type not allowed',
    dropToReplace: 'Drop to replace image',
    cancelLabel: 'Cancel upload',
    previewAlt: 'Image preview',
    errors: {
      invalidType: 'File type not allowed',
      tooLarge: 'File too large (maximum {{size}} MB)',
      uploadFailed: 'Upload failed. Try again.',
      invalidContent: 'Invalid file: content does not match a real image',
    },
  },
  conflictModal: {
    title: 'Cannot archive',
    description: 'Service {{name}} is in use in the following packages:',
    question: 'Detach from all packages and archive anyway?',
    actions: {
      cancel: 'Cancel',
      confirm: 'Detach and archive',
    },
  },
  toasts: {
    serviceCreated: 'Service created successfully',
    serviceCreateError: 'Failed to create service. Try again.',
    serviceUpdated: 'Service updated',
    serviceUpdateError: 'Failed to update service. Try again.',
    serviceDeleted: 'Service archived',
    serviceDeleteError: 'Failed to archive service. Try again.',
    serviceRestored: 'Service restored',
    serviceRestoreError: 'Failed to restore service. Try again.',
    serviceDetached: 'Service detached from packages',
    serviceDetachError: 'Failed to detach service. Try again.',
    packageCreated: 'Package created successfully',
    packageCreateError: 'Failed to create package. Try again.',
    packageUpdated: 'Package updated',
    packageUpdateError: 'Failed to update package. Try again.',
    packageDeleted: 'Package archived',
    packageDeleteError: 'Failed to archive package. Try again.',
    packageRestored: 'Package restored',
    packageRestoreError: 'Failed to restore package. Try again.',
    saleRegistered: 'Sale registered',
    saleRegisterError: 'Failed to register sale. Try again.',
    saleCancelled: 'Sale cancelled',
    saleCancelError: 'Failed to cancel sale. Try again.',
    installmentPaidError: 'Failed to mark installment as paid. Try again.',
  },
};

export default catalogTranslateEN;
